// extracted by mini-css-extract-plugin
export default {"fileDragger":"fileDragger__F9vIHJ","fileDraggerHint":"fileDraggerHint__oV8bvg","fileDraggerHeader":"fileDraggerHeader__GYfbTU","fileDraggerIcon":"fileDraggerIcon__y0egJx"};